<template>
  <div id="app">
    <h1>Technik</h1>
    <MyLogin v-if="!username" />
    <div v-if="username">
      <MyEventList />
      <MySlotForm />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import MyEventList from "./components/MyEventList";
import MySlotForm from "./components/MySlotForm";
import MyLogin from "./components/MyLogin";

export default {
  name: "App",
  components: { MyEventList, MySlotForm, MyLogin },
  computed: {
    ...mapGetters(["username"])
  }
};
</script>

<style>
#app {
  font-family: sans-serif;
  font-size: 1.5em;
}
</style>
